import clsx from 'clsx';
import { Fragment } from 'react';

import { getGameScores } from '@/modules/rankings/ppr/helpers';
import { TournamentEventMatch } from '@/modules/rankings/ppr/types';

interface PWRMobileScoresProps {
  match: TournamentEventMatch;
  swapped?: boolean;
}

export const PWRMobileScores = ({ match, swapped }: PWRMobileScoresProps) => {
  const validGames = getGameScores(match, !!swapped);

  return (
    <div className='flex items-center justify-center border-b py-2 sm:hidden border-gray-200'>
      {validGames.map((gameData, index) => {
        const { label, teamOneScore, teamTwoScore } = gameData;
        const isEqual = teamOneScore === teamTwoScore;
        const isFirstWinning = teamOneScore > teamTwoScore;

        return (
          <Fragment key={`pwr-mobile-scores-${label}`}>
            <div className='flex flex-col items-center justify-center'>
              <p className='text-xs text-gray-900'>{label}</p>
              <div className='flex text-lg'>
                <p
                  className={clsx({
                    'text-gray-900': isEqual,
                    'text-[#5925DC] font-semibold': !isEqual && isFirstWinning,
                    'text-gray-900 font-normal': !isEqual && !isFirstWinning,
                  })}
                >
                  {teamOneScore}
                </p>
                <span className='mx-0.5'>-</span>
                <p
                  className={clsx({
                    'text-gray-900': isEqual,
                    'text-[#5925DC] font-semibold': !isEqual && !isFirstWinning,
                    'text-gray-900 font-normal': !isEqual && isFirstWinning,
                  })}
                >
                  {teamTwoScore}
                </p>
              </div>
            </div>
            {index < validGames.length - 1 && <span className='mx-3 h-[14px] w-0.5 bg-gray-300' />}
          </Fragment>
        );
      })}
    </div>
  );
};
